export default "__VITE_ASSET__CFg6qxDV__"